import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  fetchTickets: `${NAMESPACE}_FETCH_TICKETS_HUB`,
  setLoading: `${NAMESPACE}_SET_LOADING_TICKETS_HUB`,
  setTicketsToState: `${NAMESPACE}_SET_TICKETS_TO_STATE_TICKETS_HUB`,
  toggleHub: `${NAMESPACE}_TOOGLE_HUB_ON_STATE_TICKETS_HUB`,
  updateTicketAccepted: `${NAMESPACE}_UPDATE_TICKET_ACCEPTED_ON_STATE_TICKETS_HUB`,
  updateTicketStatus: `${NAMESPACE}_UPDATE_TICKET_STATUS_ON_STATE_TICKETS_HUB`
};

export const actionCreators = {
  fetchTickets: (payload) => ({ type: actions.fetchTickets, payload }),
  toggleHub: (payload) => ({ type: actions.toggleHub, payload }),
  updateTicketStatus: (payload) => ({ type: actions.updateTicketStatus, payload })
};

export default {
  actions,
  actionCreators
};
